var React = require('react');

function Tatara (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Tatara"),React.createElement("g",{"id":"g1487","key":2},[React.createElement("path",{"id":"path1828","className":"cls-1","d":"M89,98h8.33V73H114V39.68H14V73H30.66V98H39","key":0}),React.createElement("path",{"id":"path1830","className":"cls-1","d":"M64,56.35v50","key":1})])]);
}

Tatara.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Tatara;

Tatara.default = Tatara;
